export function EmptyNotifications({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="200"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 176C128.719 176 152 171.971 152 167C152 162.029 128.719 158 100 158C71.2812 158 48 162.029 48 167C48 171.971 71.2812 176 100 176Z"
          fill="var(--clr-title)"
          fillOpacity="0.05"
        />
        <path
          d="M104 58C108 44 96 40 92 32C89 26 96 20 104 22"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          d="M106 22C112 18 118 20 119 26C113 28 108 26 106 22Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M106 22C104 16 108 11 114 11C114 17 111 21 106 22Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M100 60C77 60 64 78 62 104C60 126 53 138 44 147C40 151 43 156 49 156H151C157 156 160 151 156 147C147 138 140 126 138 104C136 78 123 60 100 60Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M100 53C101.857 53 103.637 53.7375 104.95 55.0503C106.262 56.363 107 58.1435 107 60H93C93 58.1435 93.7375 56.363 95.0503 55.0503C96.363 53.7375 98.1435 53 100 53Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M100 171.5C104.142 171.5 107.5 168.142 107.5 164C107.5 159.858 104.142 156.5 100 156.5C95.8579 156.5 92.5 159.858 92.5 164C92.5 168.142 95.8579 171.5 100 171.5Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M84 104C88 108.667 92 108.667 96 104"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 104C108 108.667 112 108.667 116 104"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 118C97.3333 122 102.667 122 108 118"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 116.5C80.1569 116.5 81.5 115.157 81.5 113.5C81.5 111.843 80.1569 110.5 78.5 110.5C76.8431 110.5 75.5 111.843 75.5 113.5C75.5 115.157 76.8431 116.5 78.5 116.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 116.5C120.157 116.5 121.5 115.157 121.5 113.5C121.5 111.843 120.157 110.5 118.5 110.5C116.843 110.5 115.5 111.843 115.5 113.5C115.5 115.157 116.843 116.5 118.5 116.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M150 92L152 97L157 99L152 101L150 106L148 101L143 99L148 97L150 92Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M46 102.6C47.4359 102.6 48.6 101.436 48.6 100C48.6 98.5641 47.4359 97.4 46 97.4C44.5641 97.4 43.4 98.5641 43.4 100C43.4 101.436 44.5641 102.6 46 102.6Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
